<template>
    <div>
        <limitless-page-header sub-title="Restade leveranser"></limitless-page-header>

        <div class="content" v-if="loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div v-else class="content">
            <div class="card">
                <div class="card-body">
                    <div class="btn-group">
                        <button class="btn btn-light" :class="{ 'active': mode === 'all' }" @click="mode = 'active'">
                            Alla <span class="badge badge-pill ml-1" :class="{ 'badge-danger': num_all > 0, 'badge-dark': num_all <= 0 }">{{ num_all }}</span>
                        </button>
                        <button class="btn btn-light" :class="{ 'active': mode === 'not_rest' }" @click="mode = 'not_rest'">
                            Ej restade <span class="badge badge-pill ml-1" :class="{ 'badge-danger': num_not_rest > 0, 'badge-dark': num_not_rest <= 0 }">{{ num_not_rest }}</span>
                        </button>
                        <button class="btn btn-light" :class="{ 'active': mode === 'needs_contact' }" @click="mode = 'needs_contact'">
                            Ej kontaktade <span class="badge badge-pill ml-1" :class="{ 'badge-danger': num_needs_contact > 0, 'badge-dark': num_needs_contact <= 0 }">{{ num_needs_contact }}</span>
                        </button>
                        <button class="btn btn-light" :class="{ 'active': mode === 'needs_purchase' }" @click="mode = 'needs_purchase'">
                            Ej beställda <span class="badge badge-pill ml-1" :class="{ 'badge-danger': num_needs_purchase > 0, 'badge-dark': num_needs_purchase <= 0 }">{{ num_needs_purchase }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-group-control card-group-control-left">
                <div
                    v-for="(item) in filtered_products"
                    :key="'product-' + item.product.ProdID"
                    class="card overflow-hidden"
                >
                    <div
                        class="card-header p-0"
                        :style="{ 'background-color': item.product.isPhasedOut === 1 ? '#C62828' : '#1565C0' }"
                    >
                        <table
                            class="table text-white"
                        >
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="card-title d-inline-block pr-3">
                                            <a data-toggle="collapse" class="collapsed text-white font-weight-semibold font-size-lg position-relative" :href="'#collapse-' + item.product.ProdID"
                                            >{{ item.product.ProdID }} - {{ item.product.ProdName }}</a>
                                        </div>
                                        <a class="text-white font-weight-semibold font-size-lg position-relative" :href="'/products/' + item.product.ProdID"
                                        ><i class="icon-link"></i></a>
                                    </td>
                                    <td style="width: 260px; padding-top: 5px; padding-bottom: 5px;">
                                        <div class="font-weight-semibold">
                                            <span v-if="item.product.isNonStockItem">Beställningsvara</span>
                                            <span v-else-if="!item.product.BackInStockDate">Blockerad i inlösen</span>
                                        </div>
                                        <div v-if="item.product.purchase_items && item.product.purchase_items.length > 0">
                                            <div
                                                v-for="purchase in item.product.purchase_items"
                                                :key="'product-' + item.product.ProdID + '-purchase-' + purchase.RowID"
                                            >Kommande leverans: {{ purchase.EffectiveTS ? purchase.EffectiveTS.substring(0, 10) : 'Okänt datum' }}, {{ purchase.Antal }}st</div>
                                        </div>
                                        <div v-else>Inga kommande leveranser</div>
                                    </td>
                                    <td style="width: 300px;">
                                        <div v-if="item.product.isStruct" class="badge badge-info">STRUKTURARTIKEL</div>
                                        <div v-if="item.product.isPhasedOut === 1" class="badge badge-danger">HAR UTGÅTT</div>
                                        <div v-else>
                                            <div v-if="item.product.isNonStockItem" class="badge badge-warning">Beställningsvara</div>
                                            <div v-if="item.product.isOutOfStock === 1">
                                                <div class="badge badge-danger">TILLF. SLUT</div>
                                                <div v-if="item.product.no_refill && !(item.product.BackInStockDate && item.product.BackInStockDate != '0000-00-00')" class="badge badge-purple">EJ REFILL</div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div :id="'collapse-' + item.product.ProdID" class="collapse">
                        <div class="table-responsive mb-0">
                            <table class="table table-xs">
                                <thead>
                                    <tr>
                                        <th style="width: 125px;">Ber. lev.datum</th>
                                        <th style="width: 170px;">Önskad lev.datum (skickas datum)</th>
                                        <th style="width: 140px;">Kort</th>
                                        <th style="width: 150px;">Status</th>
                                        <th>Namn</th>
                                        <th>Adress</th>
                                        <th style="width: 68px;">Land</th>
                                        <th>Produkter</th>
                                        <th style="width: 120px;">Kortorder</th>
                                        <th style="width: 150px;">Kontakt</th>
                                        <th style="width: 100px;">Mail</th>
                                        <th style="width: 30px;">
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'chk-product-' + item.product.ProdID + '-all'"
                                                    v-model="checkall[item.product.ProdID]"
                                                    @click="checkAll(item, checkall[item.product.ProdID])"
                                                />
                                                <label class="custom-control-label pr-1" :for="'chk-product-' + item.product.ProdID + '-all'">&nbsp;</label>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(order) in item.orders"
                                        :key="'product-' + item.product.ProdID + '-prodorder-' + order.ProdOrderID"
                                    >
                                        <td>
                                            <i
                                                class="icon"
                                                :class="[getOrderItemIcon(item.product, order.items)]"
                                            ></i>
                                            <span>({{ getOrderItemProdLagerDate(item.product.ProdID, order, item.product.purchase_items) }})</span>
                                        </td>
                                        <td><a :href="'/prodorders/' + order.ProdOrderID" :title="'inlöst: ' + formatDateTime(order.OrderTS) + ' via ' + order.Source"
                                               :class="getStatusClass(order.StatusID, order)">{{ order.WantedDeliveryDate }} <span style="font-weight: normal;">({{ order.CalcShippingDate }})</span></a>
                                        </td>
                                        <td><a :href="'/prodorders/' + order.ProdOrderID" :class="getStatusClass(order.StatusID, order)">{{ order.CardNo }}</a></td>
                                        <td><a :href="'/prodorders/' + order.ProdOrderID" :class="getStatusClass(order.StatusID, order)">{{ getStatusName(order.StatusID, order) }}</a></td>
                                        <td><a :href="'/prodorders/' + order.ProdOrderID" :class="getStatusClass(order.StatusID, order)">{{ order.Name }}</a></td>
                                        <td><a :href="'/prodorders/' + order.ProdOrderID" :class="getStatusClass(order.StatusID, order)">{{ order.Street }}, {{ order.Zip }}, {{ order.City }}</a></td>
                                        <td><a :href="'/prodorders/' + order.ProdOrderID" :class="getStatusClass(order.StatusID, order)">{{ order.CountryCode }}</a></td>
                                        <td><a :href="'/prodorders/' + order.ProdOrderID" :class="getStatusClass(order.StatusID, order)">{{ getOrderProducts(item.product.ProdID, order.items) }}</a></td>
                                        <td><a :href="'/cardorders/' + order.card.OrderID" :class="getStatusClass(order.StatusID, order)">Order {{ order.card.OrderID }}</a></td>
                                        <td style="padding-top: 2px; padding-bottom: 2px;">
                                            <div>
                                                Skickade mail: {{ order.num_rest_contacts }} st
                                            </div>
                                            <div>
                                                Senaste: {{ order.last_contact ? formatDateTime(order.last_contact).substring(0, 10) : '-' }}
                                            </div>
                                        </td>
                                        <td style="padding-top: 2px; padding-bottom: 2px;">
                                            <button
                                                v-if="order.needs_contact"
                                                class="btn btn-sm btn-light"
                                                @click="showModalMail(item.product.isPhasedOut === 1 ? 'phased_out' : 'delayed_delivery', order, item.product.ProdID)"
                                            ><i class="icon-paperplane mr-1" />Skicka</button>
                                        </td>
                                        <td>
                                            <div class="custom-control custom-checkbox">
                                                <input
                                                    type="checkbox"
                                                    class="custom-control-input"
                                                    :id="'chk-product-' + item.product.ProdID + '-prodorder-' + order.ProdOrderID"
                                                    v-model="checked_orders" :value="order.ProdOrderID"
                                                    :disabled="!order.needs_contact"
                                                />
                                                <label class="custom-control-label pr-1" :for="'chk-product-' + item.product.ProdID + '-prodorder-' + order.ProdOrderID">&nbsp;</label>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="12">Totalt {{ item.orders.length }} st leveranser</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div class="input-group" style="max-width: 400px;">
                    <vue-select
                        placeholder="Välj funktion"
                        :options="[
                            { id: 'send-mail', label: '✨Uppdatera skickas-datum och meddela kund' },
                            { id: 'multi-comment', label: 'Multikommentar + statusändring' },
                            { id: 'multi-contact', label: 'Multikommentar + kunduppdatering' },
                        ]"
                        v-model="action"
                        :reduce="(opt) => opt.id"
                    ></vue-select>
                    <span class="input-group-append">
                        <limitless-button btn-class="btn-light" :disabled="visible_checked_orders.length <= 0" @click="doAction">»»»</limitless-button>
                    </span>
                </div>
            </div>
        </div>

        <b-modal
            id="modal_mail_preview"
            :title="'Skicka mail'"
            key="modal_mail_preview"
            ok-title="Skicka"
            cancel-title="Stäng"
            cancel-variant="light"
            size="xl"
            @ok="sendMail"
        >
            <div v-if="mail_prodorder">
                <ValidationObserver ref="mailform">
                    <div class="form-group row">
                        <label class="col col-form-label" style="max-width: 150px;">Till:</label>
                        <div class="col" style="max-width: 500px;">
                            <input type="text" :value="mail_prodorder.Email" class="form-control" readonly>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col col-form-label" style="max-width: 150px;">Meddelande:</label>
                        <div class="col" style="max-width: 500px;">
                            <ValidationProvider vid="message" name="Meddelande" v-slot="{ errors }">
                                <elastic-textarea type="text" v-model="mail.message" class="form-control" :class="{'border-danger':errors[0]}" :strip-tags="false"></elastic-textarea>
                                <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                </ValidationObserver>
                <hr>
                <iframe
                    v-if="mail_preview_url"
                    :src="mail_preview_url"
                    style="border: 0; width: 100%;"
                    :style="{ height: '1700px' }"
                ></iframe>
            </div>
            <template #modal-footer="{ ok, cancel }">
                <button type="button" class="btn btn-light" @click="cancel">Stäng</button>
                <limitless-button ref="btnsendmail" icon="icon-paperplane" @click="ok" :disabled="!mail_prodorder.Email">Skicka</limitless-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import apiClient from '@services/ApiClient';
import BackendRepository from '@services/repositories/BackendRepository';
import {
    keyBy,
    sumBy,
} from 'lodash';
import getError from '@services/ErrorHelper';
import ElasticTextarea from '@components/ElasticTextarea.vue';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import VueSelect
    from '@components/Wrappers/VueSelect.vue';
import {
    formatDateTime,
} from '@services/Helpers';

export default {
    name: 'BackorderList',
    components: {
        VueSelect,
        LimitlessButton,
        ElasticTextarea,
        LimitlessPageHeader,
    },
    data: () => ({
        loading: true,
        products: null,
        statuses: null,
        mode: 'all',
        mail_prodorder: null,
        mail: {
            prod_order_id: null,
            prod_id: null,
            mail_type: null,
            message: null,
        },
        mail_preview_url: null,
        checkall: {},
        checked_orders: [],
        action: null,
    }),
    mounted() {
        BackendRepository.getStatuses().then((response) => {
            this.statuses = keyBy(response, 'id');
        });
        this.getBackorderProducts();
    },
    methods: {
        formatDateTime,
        getBackorderProducts() {
            this.loading = true;
            apiClient.get('/vue/backorders/products')
                .then((response) => {
                    this.products = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getOrderItem(prodId, orderItems) {
            if (prodId && Array.isArray(orderItems) && orderItems.length > 0) {
                return orderItems.find((oi) => oi.ProdID === prodId);
            }
            return null;
        },
        getOrderItemIcon(product, orderItems) {
            const orderItem = this.getOrderItem(product.ProdID, orderItems);
            if (orderItem) {
                if ((product.sendByExternalSupplier && orderItem.ExportedTS) || (orderItem.DeliveredTS && orderItem.DeliveredTS !== '0000-00-00 00:00:00')) {
                    return 'icon-check text-success';
                }
                if (product.sendByExternalSupplier || orderItem.IsReserved) {
                    return 'icon-check text-primary';
                }
            }
            return 'icon-cross text-danger';
        },
        getOrderItemProdLagerDate(prodId, order, prodLagers) {
            if (Array.isArray(prodLagers) && prodLagers.length > 0) {
                const orderItem = this.getOrderItem(prodId, order.items);
                if (orderItem) {
                    if (orderItem.IsReserved) {
                        return order.CalcShippingDate;
                    }
                    if (orderItem.ProdLagerID) {
                        const prodLager = prodLagers.find((pl) => pl.RowID === orderItem.ProdLagerID);
                        if (prodLager) {
                            if (prodLager.EffectiveTS) {
                                return prodLager.EffectiveTS.substring(0, 10);
                            }
                            return 'okänt datum';
                        }
                    }
                }
            }
            return 'ej beställd';
        },
        getStatusClass(statusId, order = null) {
            if (order && order.card.isBlocked) {
                return 'font-weight-semibold text-danger';
            }
            if (this.statuses[statusId]) {
                return 'font-weight-semibold text-' + this.statuses[statusId].class;
            }
            return 'font-weight-semibold text-base';
        },
        getStatusName(statusId, order = null) {
            if (order && order.card.isBlocked) {
                return 'Spärrad';
            }
            if (statusId > 0 && this.statuses[statusId]) {
                return this.statuses[statusId].name;
            }
            return 'Inlöst';
        },
        getOrderProducts(prodId, orderItems) {
            const mainItem = this.getOrderItem(prodId, orderItems);
            const otherItems = orderItems.filter((oi) => oi.ProdID !== prodId).map((oi) => oi.ProdName);
            return mainItem.ProdName + (otherItems.length > 0 ? ' + (' + otherItems.join(', ') + ')' : '');
        },
        showModalMail(mailType, prodOrder, prodId) {
            this.mail_prodorder = prodOrder;
            this.mail.prod_order_id = prodOrder.ProdOrderID;
            this.mail.prod_id = prodId;
            this.mail.mail_type = mailType;
            this.updateMailPreview();
            this.$root.$bvModal.show('modal_mail_preview');
        },
        async sendMail(event) {
            event.preventDefault();
            await apiClient.post('/vue/prodorders/' + this.mail.prod_order_id + '/send/' + this.mail.mail_type, { ...this.mail })
                .then(() => {
                    const message = 'Mail skickad!';
                    this.$root.$bvModal.hide('modal_mail_preview');
                    this.$swal({
                        icon: 'success',
                        title: message,
                        confirmButtonText: 'OK',
                        showCancelButton: false,
                        timer: 2222,
                    });
                    this.getBackorderProducts();
                }).catch((error) => {
                    this.$refs.btnsendmail.triggerFailed();
                    const parsederror = getError(error);
                    if (typeof parsederror === 'object') {
                        this.$refs.mailform.setErrors(parsederror);
                    } else {
                        let message = 'Något gick fel...';
                        if (error.response && error.response.data && error.response.data.message) {
                            message = error.response.data.message;
                        }
                        this.$swal({
                            icon: 'error',
                            title: 'Error!',
                            text: message,
                            confirmButtonText: 'OK',
                            cancelButtonText: 'Avbryt',
                        });
                    }
                });
            this.action = null;
            this.resetCheckboxes();
        },
        updateMailPreview() {
            apiClient.get('/vue/backorders/getmailmessage', {
                params: this.mail,
            }).then((response) => {
                this.mail.message = response.data.message;
                this.mail_preview_url = '/prodorders/' + this.mail.prod_order_id + '/mailpreview/' + this.mail.mail_type + '?' + Object.keys(this.mail).filter((k) => this.mail[k]).map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(this.mail[k])}`).join('&');
            });
        },
        checkAll(item, checked) {
            this.checkall[item.product.ProdID] = !checked;
            const orderIds = item.orders.filter((o) => o.needs_contact).map((o) => o.ProdOrderID);
            if (!checked) {
                this.checked_orders = [...this.checked_orders, ...orderIds];
            } else {
                this.checked_orders = this.checked_orders.filter((oId) => !orderIds.includes(oId));
            }
        },
        async doAction() {
            if (this.action === 'send-mail') {
                let doSend = false;
                await this.$swal({
                    text: 'Är du säker att du vill uppdatera skickas-datum och meddela kund om förseningen?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, uppdatera och meddela!',
                    cancelButtonText: 'Avbryt',
                })
                    .then((result) => {
                        if (result.isConfirmed) {
                            doSend = true;
                        }
                    });

                if (doSend) {
                    apiClient.post('/vue/backorders/updateshippingdateandsendemail', {
                        prod_order_ids: this.checked_orders,
                    }).then(() => {
                        this.$swal({
                            title: 'Klart!',
                            text: 'Mailet har skickats!',
                            icon: 'success',
                            timer: 3000,
                        });
                        this.getBackorderProducts();
                    }).catch((error) => {
                        let message = 'Mailet kunde ej skickas.';
                        if (error.response && error.response.data && error.response.data.message) {
                            message = error.response.data.message;
                        }
                        this.$swal({
                            title: 'Något gick fel...',
                            text: message,
                            icon: 'error',
                            timer: 3000,
                        });
                    });
                }
            } else if (this.action === 'multi-comment') {
                window.location.href = '/batch/list?type=prod_order&func=comment&ids[]=' + this.checked_orders.join('&ids[]=');
            } else if (this.action === 'multi-contact') {
                window.location.href = '/batch/list?type=prod_order&func=contact&ids[]=' + this.checked_orders.join('&ids[]=');
            }
            this.action = null;
            this.resetCheckboxes();
        },
        resetCheckboxes() {
            this.checked_orders = [];
            Object.keys(this.checkall).forEach((key) => {
                this.checkall[key] = false;
            });
        },
    },
    computed: {
        filtered_products() {
            if (this.mode === 'needs_contact') {
                return JSON.parse(JSON.stringify(this.products)).map((item) => {
                    item.orders = item.orders.filter((o) => o.needs_contact);
                    return item;
                }).filter((item) => item.orders.length > 0);
            }
            if (this.mode === 'not_rest') {
                return JSON.parse(JSON.stringify(this.products)).map((item) => {
                    item.orders = item.orders.filter((o) => o.StatusID !== 250);
                    return item;
                }).filter((item) => item.orders.length > 0);
            }
            if (this.mode === 'needs_purchase') {
                return JSON.parse(JSON.stringify(this.products)).map((item) => {
                    item.orders = item.orders.filter((o) => o.items.filter((i) => !i.ProdLagerID).length > 0);
                    return item;
                }).filter((item) => item.orders.length > 0);
            }
            return this.products;
        },
        num_all() {
            let total = 0;
            if (this.products) {
                this.products.forEach((item) => {
                    total += item.orders.length;
                });
            }
            return total;
        },
        num_not_rest() {
            let total = 0;
            if (this.products) {
                this.products.forEach((item) => {
                    total += sumBy(item.orders, (order) => (order.StatusID !== 250 ? 1 : 0));
                });
            }
            return total;
        },
        num_needs_contact() {
            let total = 0;
            if (this.products) {
                this.products.forEach((item) => {
                    total += sumBy(item.orders, 'needs_contact');
                });
            }
            return total;
        },
        num_needs_purchase() {
            let total = 0;
            if (this.products) {
                this.products.forEach((item) => {
                    total += item.orders.filter((o) => o.items.filter((i) => !i.ProdLagerID).length > 0).length;
                });
            }
            return total;
        },
        visible_checked_orders() {
            let visibleOrdersIds = [];
            if (Array.isArray(this.filtered_products)) {
                this.filtered_products.forEach((item) => {
                    visibleOrdersIds = [...visibleOrdersIds, ...item.orders.map((o) => o.ProdOrderID)];
                });
            }
            return this.checked_orders.filter((oId) => visibleOrdersIds.includes(oId));
        },
    },
};
</script>
